/*
 * jquery.dragScroll v1.0.0
 * author 735126858@qq.com
 * https://github.com/YuTingtao/dragScroll.js
 */
;(function(factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory( jQuery );
    }
}(function($){
    var methods = {
        init: function(options) {
            var defaults = {
                direction: null,
                throttleTime: 50,  // 节流时间
                onStart: function() {},
                onMove: function() {},
                onEnd: function() {}
            };

            var opt = $.extend({}, defaults, options);

            function getPosition( transform ) {
                let arr
                try {
                    arr = transform.split(/[()]/)[1].split(',');
                } catch (e) {
                    arr = ['0','0']
                }    
                 return {
                    left: parseInt(arr[0].trim()),
                    top: parseInt(arr[1].trim()),
                 }               
            }

            return this.each(function() {
                var $this = $(this),
                    _dir = opt.direction,
                    _throttleTime = opt.throttleTime,
                    _onStart = opt.onStart,
                    _onMove = opt.onMove,
                    _onEnd = opt.onEnd;

                var left0, top0, x0, y0, flag = false;

                    // 阻止冒泡
                    $this.children('input, textarea, button').on('mousedown.ds mousemove.ds', function(e) {
                        stopBubble(e);
                    });
                    // 鼠标按下
                    $this.on('mousedown.ds', function(e) {
                        var e = e || window.event;
                        flag = true;
                        x0 = e.clientX;
                        y0 = e.clientY;

                        const position = getPosition( $(this).parent()?.get(0)?.style.transform )
                        left0 = position.left
                        top0 = position.top
                        /*
                        left0 = $(this).parent().scrollLeft();
                        top0 = $(this).parent().scrollTop();
                        */
                        let isContinue =  _onStart?.call(this, $this);
                        if(!isContinue) return

                        // 鼠标移动
                        $this.on('mousemove.ds', function(e) {
                            e.preventDefault();
                            var e = e || window.event;
                            if (flag) {
                                var timeout = null;
                                if(timeout == null) {
                                    timeout = setTimeout(function() {
                                        var moveX = parseInt(e.clientX - x0);
                                        var moveY = parseInt(e.clientY - y0);
                                        if (_dir == 'scrollLeft') {
                                            // $this.parent().scrollLeft(left0 - moveX);
                                            //$this.parent().get(0).style.transform = `translate3d(-${left0 - moveX}px, -${top0}px, 0px)`
                                            _onMove.call(this, {top: top0, left: -(left0 + moveX)})

                                        } else if (_dir == 'scrollTop') {
                                            // $this.parent().scrollTop(top0 - moveY);
                                            // $this.parent().get(0).style.transform = `translate3d(-${left0}px, -${top0 - moveY}px, 0px)`
                                            _onMove.call(this, {top: -(top0 + moveY), left:left0})
                                        } else {
                                            //$this.parent().get(0).style.transform = `translate3d(-${left0 - moveX}px, -${top0 - moveY}px, 0px)`
                                            // $this.parent().scrollLeft(left0 - moveX);
                                            // $this.parent().scrollTop(top0 - moveY);
                                            _onMove.call(this, {top: -(top0 + moveY), left: -(left0 + moveX)})

                                        }
                                        timeout = null;
                                    }, _throttleTime);
                                }
                                // _onMove && _onMove.call(this, $this);
                            }
                        });

                        // 鼠标松开或离开
                        $this.on('mouseup.ds mouseleave.ds', function() {
                            if (flag) {
                                _onEnd && _onEnd.call(this, $this);
                            }
                            flag = false;
                            $this.off('mousemove.ds mouseup.ds mouseleave.ds');
                        });
                    });
                
            });
        },
        destroy: function() {
            console.log('destroy')
            return $(this).each(function() {
                var $this = $(this);
                $this.off('mousedown.ds mousemove.ds mouseup.ds mouseleave.ds');
                $this.off('touchstart.ds touchmove.ds touchend.ds')
                $this.children('input, textarea, button').off('mousedown.ds mousemove.ds')
            });
        }
    };

    function stopBubble(e) { 
		if (e && e.stopPropagation) {
		　　e.stopPropagation(); 
		} else {// IE浏览器 
			window.event.cancelBubble = true; 
		} 
	} 

    $.fn.dragScroll = function(method) {
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('method ' + method + ' does not exist on jquery.dragScroll.js');
        }
    }
}));